export default "__VITE_ASSET__C2fk37FN__"